import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import ActionTypes from '../../../constants/ActionTypes';
import common, { DEFAULT_INITIAL_STATE } from '../../_common/reducers';
import commonHelpers from '../../_common/helpers';
export var INITIAL_STATE = _objectSpread(_objectSpread({}, DEFAULT_INITIAL_STATE), {}, {
  byDataSourceKey: {}
});
/**
 * Add attribute data
 * @param state {Object}
 * @param attributeDataSourceKey {string} attribute data source key
 * @param data {Object} feature key - attribute value pairs
 * @return {Object}
 */

var add = function add(state, attributeDataSourceKey, data) {
  if (attributeDataSourceKey && data) {
    return _objectSpread(_objectSpread({}, state), {}, {
      byDataSourceKey: _objectSpread(_objectSpread({}, state.byDataSourceKey), {}, _defineProperty({}, attributeDataSourceKey, data))
    });
  } else {
    return state;
  }
};
/**
 * Update attribute data for given data source
 * @param state {Object}
 * @param attributeDataSourceKey {string} attribute data source key
 * @param data {Object} feature key - attribute value pairs
 * @return {Object}
 */


var update = function update(state, attributeDataSourceKey, data) {
  if (attributeDataSourceKey && data) {
    return _objectSpread(_objectSpread({}, state), {}, {
      byDataSourceKey: _objectSpread(_objectSpread({}, state.byDataSourceKey), {}, _defineProperty({}, attributeDataSourceKey, state.byDataSourceKey[attributeDataSourceKey] ? _objectSpread(_objectSpread({}, state.byDataSourceKey[attributeDataSourceKey]), data) : data))
    });
  } else {
    return state;
  }
};
/**
 * @param state {Object}
 * @param attributeDataSourceKey {string} uuid
 * @param data {Object} attribute data
 * @param filter {Object}
 * @param order {Array}
 * @param indexData {Array}
 * @param changedOn {string}
 * @return {Object}
 */


var addWithSpatialIndex = function addWithSpatialIndex(state, attributeDataSourceKey, data, filter, order, indexData, changedOn) {
  var byDataSourceKey = _objectSpread(_objectSpread({}, state.byDataSourceKey), {}, _defineProperty({}, attributeDataSourceKey, state.byDataSourceKey[attributeDataSourceKey] ? _objectSpread(_objectSpread({}, state.byDataSourceKey[attributeDataSourceKey]), data) : data));

  var updatedIndexes = commonHelpers.getUpdatedIndexes(state, filter, order, indexData, changedOn, 'spatialIndexes');
  return _objectSpread(_objectSpread({}, state), {}, {
    byDataSourceKey: byDataSourceKey,
    spatialIndexes: updatedIndexes
  });
};
/**
 * Add data and index in one step to save more mutating state
 * @param state {Object}
 * @param index {Array} ordered index
 * @param data {Object} Object with data
 * @param filter {Array}
 * @param order {Array}
 * @param start {Array}
 * @param total {Array}
 * @param changedOn {string}
 * @param limit {Number} Limitation for loading data
 * @return {Object}
 */


var addWithIndex = function addWithIndex(state, index, data, filter, order, start, total, changedOn, limit) {
  // TODO test commonHelpers.getUpdatedByDataSourceKey properly
  var byDataSourceKey = commonHelpers.getUpdatedByDataSourceKey(state.byDataSourceKey, data); // Fake new data object for common action
  // Action "common.addIndex" needs array of data objects with key to create new index.
  // "newData" is a Array of the minimal data for construct index in common actoin.

  var newData = index.map(function (val) {
    return {
      key: val
    };
  });

  var addIndexAction = _objectSpread({
    filter: filter,
    order: order,
    data: newData,
    start: start,
    count: total,
    changedOn: changedOn
  }, limit && {
    limit: limit
  });

  var stateWithUpdatedIndexes = common.addIndex(state, addIndexAction);
  return _objectSpread(_objectSpread({}, state), {}, {
    byDataSourceKey: byDataSourceKey,
    indexes: stateWithUpdatedIndexes.indexes
  });
};
/**
 * Add spatial index
 * @param state {Object}
 * @param filter {Object}
 * @param order {Array}
 * @param indexData {Array}
 * @param changedOn {string}
 * @return {*&{spatialIndexes: []}}
 */


var addSpatialIndex = function addSpatialIndex(state, filter, order, indexData, changedOn) {
  var updatedIndexes = commonHelpers.getUpdatedIndexes(state, filter, order, indexData, changedOn, 'spatialIndexes');
  return _objectSpread(_objectSpread({}, state), {}, {
    spatialIndexes: updatedIndexes
  });
};
/**
 * Remove spatial index that fit to filter and order from state.
 * @param {Object} state
 * @param {Object} filter
 * @param {Object} order
 * @return {Object}
 */


var removeSpatialIndex = function removeSpatialIndex(state, filter, order) {
  var updatedIndexes = commonHelpers.removeIndex(state.spatialIndexes, filter, order);
  return _objectSpread(_objectSpread({}, state), {}, {
    spatialIndexes: updatedIndexes
  });
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.DATA.ATTRIBUTE_DATA.ADD:
      return add(state, action.key, action.data);

    case ActionTypes.DATA.ATTRIBUTE_DATA.ADD_WITH_SPATIAL_INDEX:
      return addWithSpatialIndex(state, action.attributeDataSourceKey, action.data, action.filter, action.order, action.indexData, action.changedOn);

    case ActionTypes.DATA.ATTRIBUTE_DATA.ADD_WITH_INDEX:
      return addWithIndex(state, action.index, action.data, action.filter, action.order, action.start, action.total, action.changedOn, action.limit);

    case ActionTypes.DATA.ATTRIBUTE_DATA.UPDATE:
      return update(state, action.key, action.data);

    case ActionTypes.DATA.ATTRIBUTE_DATA.INDEX.ADD:
      return common.addIndex(state, action);

    case ActionTypes.DATA.ATTRIBUTE_DATA.SPATIAL_INDEX.ADD:
      return addSpatialIndex(state, action.filter, action.order, action.indexData, action.changedOn);

    case ActionTypes.DATA.ATTRIBUTE_DATA.SPATIAL_INDEX.REMOVE:
      return removeSpatialIndex(state, action.filter, action.order);

    case ActionTypes.DATA.ATTRIBUTE_DATA.UPDATE_STORE:
      return common.updateStore(state, action.data);

    default:
      return state;
  }
});